/* tslint:disable */
/* eslint-disable */
/**
 * UserManagement API
 * This is an OpenAPI for the UserManagement Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AddUserRequest } from '../models';
import { AddUserResponse } from '../models';
import { AdminChangePasswordRequest } from '../models';
import { AdminChangePasswordResponse } from '../models';
import { DeleteUserResponse } from '../models';
import { EditUserRequest } from '../models';
import { EditUserResponse } from '../models';
import { GetUserProfileResponse } from '../models';
import { GetUserResponse } from '../models';
import { GetUsersByIdsBasicInfoResponse } from '../models';
import { GetUsersByIdsResponse } from '../models';
import { LoginRequest } from '../models';
import { LoginResponse } from '../models';
import { PersonalChangePasswordRequest } from '../models';
import { PersonalChangePasswordResponse } from '../models';
import { ResetPasswordByIndRequest } from '../models';
import { ResetPasswordByIndResponse } from '../models';
import { SetNewPasswordRequest } from '../models';
import { SetNewPasswordResponse } from '../models';
import { User } from '../models';
/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds User to Platform
         * @summary Add User to Platform
         * @param {AddUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser: async (body?: AddUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * An Api to change Employee Password by Admin
         * @summary Change Employee Password by the Admin
         * @param {string} UserID id value that needs to be considered for filter
         * @param {AdminChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangePassword: async (UserID: string, body?: AdminChangePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserID' is not null or undefined
            if (UserID === null || UserID === undefined) {
                throw new RequiredError('UserID','Required parameter UserID was null or undefined when calling adminChangePassword.');
            }
            const localVarPath = `/User/AdminChangePassword/{UserID}`
                .replace(`{${"UserID"}}`, encodeURIComponent(String(UserID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Platform User.
         * @summary Delete Platform User
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (UserID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserID' is not null or undefined
            if (UserID === null || UserID === undefined) {
                throw new RequiredError('UserID','Required parameter UserID was null or undefined when calling deleteUser.');
            }
            const localVarPath = `/User/{UserID}`
                .replace(`{${"UserID"}}`, encodeURIComponent(String(UserID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit platform User profile
         * @summary Edit Platform User
         * @param {string} UserID id value that needs to be considered for filter
         * @param {EditUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUser: async (UserID: string, body?: EditUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserID' is not null or undefined
            if (UserID === null || UserID === undefined) {
                throw new RequiredError('UserID','Required parameter UserID was null or undefined when calling editUser.');
            }
            const localVarPath = `/User/{UserID}`
                .replace(`{${"UserID"}}`, encodeURIComponent(String(UserID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets Platform User by ID.
         * @summary Gets Platform User by ID
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (UserID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserID' is not null or undefined
            if (UserID === null || UserID === undefined) {
                throw new RequiredError('UserID','Required parameter UserID was null or undefined when calling getUserById.');
            }
            const localVarPath = `/User/{UserID}`
                .replace(`{${"UserID"}}`, encodeURIComponent(String(UserID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets Platform UserProfile by ID.
         * @summary Gets Platform User's Profile (No sensitive data) by ID
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfileById: async (UserID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserID' is not null or undefined
            if (UserID === null || UserID === undefined) {
                throw new RequiredError('UserID','Required parameter UserID was null or undefined when calling getUserProfileById.');
            }
            const localVarPath = `/User/Profile/{UserID}`
                .replace(`{${"UserID"}}`, encodeURIComponent(String(UserID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all  Users
         * @summary Gets all Users of Platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get several users by their IDs
         * @summary Strictly internal method used by  microservices to get several users by their ids
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByIds: async (body?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get several users by their IDs with basic information
         * @summary Strictly internal method used by  microservices to get several users by their ids with basic information
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByIdsBasicInfo: async (body?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users/BasicInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Logs in User to Platform, returns general platform token.
         * @summary Login User to Platform
         * @param {LoginRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (body?: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * An api used to change personal password by user
         * @summary Change Password for User
         * @param {PersonalChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalChangePassword: async (body?: PersonalChangePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/PersonalChangePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * An api to reset password by individual
         * @summary Reset Password By Individual
         * @param {ResetPasswordByIndRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordByUser: async (body?: ResetPasswordByIndRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/ResetPasswordByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * An api used to change password of individuals with a verification code, when they forget the password
         * @summary Set New Password for User
         * @param {SetNewPasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNewPassword: async (body?: SetNewPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/SetNewPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Adds User to Platform
         * @summary Add User to Platform
         * @param {AddUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUser(body?: AddUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AddUserResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).addUser(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * An Api to change Employee Password by Admin
         * @summary Change Employee Password by the Admin
         * @param {string} UserID id value that needs to be considered for filter
         * @param {AdminChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminChangePassword(UserID: string, body?: AdminChangePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AdminChangePasswordResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).adminChangePassword(UserID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete Platform User.
         * @summary Delete Platform User
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(UserID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DeleteUserResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).deleteUser(UserID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Edit platform User profile
         * @summary Edit Platform User
         * @param {string} UserID id value that needs to be considered for filter
         * @param {EditUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUser(UserID: string, body?: EditUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EditUserResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).editUser(UserID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets Platform User by ID.
         * @summary Gets Platform User by ID
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(UserID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetUserResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).getUserById(UserID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets Platform UserProfile by ID.
         * @summary Gets Platform User's Profile (No sensitive data) by ID
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfileById(UserID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetUserProfileResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).getUserProfileById(UserID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets all  Users
         * @summary Gets all Users of Platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<User>>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).getUsers(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get several users by their IDs
         * @summary Strictly internal method used by  microservices to get several users by their ids
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByIds(body?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetUsersByIdsResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).getUsersByIds(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get several users by their IDs with basic information
         * @summary Strictly internal method used by  microservices to get several users by their ids with basic information
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByIdsBasicInfo(body?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetUsersByIdsBasicInfoResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).getUsersByIdsBasicInfo(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Logs in User to Platform, returns general platform token.
         * @summary Login User to Platform
         * @param {LoginRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(body?: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<LoginResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).login(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * An api used to change personal password by user
         * @summary Change Password for User
         * @param {PersonalChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalChangePassword(body?: PersonalChangePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PersonalChangePasswordResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).personalChangePassword(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * An api to reset password by individual
         * @summary Reset Password By Individual
         * @param {ResetPasswordByIndRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordByUser(body?: ResetPasswordByIndRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ResetPasswordByIndResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).resetPasswordByUser(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * An api used to change password of individuals with a verification code, when they forget the password
         * @summary Set New Password for User
         * @param {SetNewPasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNewPassword(body?: SetNewPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SetNewPasswordResponse>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).setNewPassword(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Adds User to Platform
         * @summary Add User to Platform
         * @param {AddUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUser(body?: AddUserRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<AddUserResponse>> {
            return UserApiFp(configuration).addUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * An Api to change Employee Password by Admin
         * @summary Change Employee Password by the Admin
         * @param {string} UserID id value that needs to be considered for filter
         * @param {AdminChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminChangePassword(UserID: string, body?: AdminChangePasswordRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<AdminChangePasswordResponse>> {
            return UserApiFp(configuration).adminChangePassword(UserID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Platform User.
         * @summary Delete Platform User
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(UserID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<DeleteUserResponse>> {
            return UserApiFp(configuration).deleteUser(UserID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit platform User profile
         * @summary Edit Platform User
         * @param {string} UserID id value that needs to be considered for filter
         * @param {EditUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUser(UserID: string, body?: EditUserRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<EditUserResponse>> {
            return UserApiFp(configuration).editUser(UserID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets Platform User by ID.
         * @summary Gets Platform User by ID
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(UserID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetUserResponse>> {
            return UserApiFp(configuration).getUserById(UserID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets Platform UserProfile by ID.
         * @summary Gets Platform User's Profile (No sensitive data) by ID
         * @param {string} UserID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfileById(UserID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetUserProfileResponse>> {
            return UserApiFp(configuration).getUserProfileById(UserID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all  Users
         * @summary Gets all Users of Platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<User>>> {
            return UserApiFp(configuration).getUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get several users by their IDs
         * @summary Strictly internal method used by  microservices to get several users by their ids
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByIds(body?: Array<string>, options?: AxiosRequestConfig): Promise<AxiosResponse<GetUsersByIdsResponse>> {
            return UserApiFp(configuration).getUsersByIds(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get several users by their IDs with basic information
         * @summary Strictly internal method used by  microservices to get several users by their ids with basic information
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByIdsBasicInfo(body?: Array<string>, options?: AxiosRequestConfig): Promise<AxiosResponse<GetUsersByIdsBasicInfoResponse>> {
            return UserApiFp(configuration).getUsersByIdsBasicInfo(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Logs in User to Platform, returns general platform token.
         * @summary Login User to Platform
         * @param {LoginRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(body?: LoginRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<LoginResponse>> {
            return UserApiFp(configuration).login(body, options).then((request) => request(axios, basePath));
        },
        /**
         * An api used to change personal password by user
         * @summary Change Password for User
         * @param {PersonalChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalChangePassword(body?: PersonalChangePasswordRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<PersonalChangePasswordResponse>> {
            return UserApiFp(configuration).personalChangePassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * An api to reset password by individual
         * @summary Reset Password By Individual
         * @param {ResetPasswordByIndRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordByUser(body?: ResetPasswordByIndRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<ResetPasswordByIndResponse>> {
            return UserApiFp(configuration).resetPasswordByUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * An api used to change password of individuals with a verification code, when they forget the password
         * @summary Set New Password for User
         * @param {SetNewPasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNewPassword(body?: SetNewPasswordRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<SetNewPasswordResponse>> {
            return UserApiFp(configuration).setNewPassword(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Adds User to Platform
     * @summary Add User to Platform
     * @param {AddUserRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async addUser(body?: AddUserRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<AddUserResponse>> {
        return UserApiFp(this.configuration).addUser(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * An Api to change Employee Password by Admin
     * @summary Change Employee Password by the Admin
     * @param {string} UserID id value that needs to be considered for filter
     * @param {AdminChangePasswordRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async adminChangePassword(UserID: string, body?: AdminChangePasswordRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<AdminChangePasswordResponse>> {
        return UserApiFp(this.configuration).adminChangePassword(UserID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete Platform User.
     * @summary Delete Platform User
     * @param {string} UserID id value that needs to be considered for filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async deleteUser(UserID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<DeleteUserResponse>> {
        return UserApiFp(this.configuration).deleteUser(UserID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Edit platform User profile
     * @summary Edit Platform User
     * @param {string} UserID id value that needs to be considered for filter
     * @param {EditUserRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async editUser(UserID: string, body?: EditUserRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<EditUserResponse>> {
        return UserApiFp(this.configuration).editUser(UserID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets Platform User by ID.
     * @summary Gets Platform User by ID
     * @param {string} UserID id value that needs to be considered for filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async getUserById(UserID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetUserResponse>> {
        return UserApiFp(this.configuration).getUserById(UserID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets Platform UserProfile by ID.
     * @summary Gets Platform User's Profile (No sensitive data) by ID
     * @param {string} UserID id value that needs to be considered for filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async getUserProfileById(UserID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetUserProfileResponse>> {
        return UserApiFp(this.configuration).getUserProfileById(UserID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all  Users
     * @summary Gets all Users of Platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async getUsers(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<User>>> {
        return UserApiFp(this.configuration).getUsers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get several users by their IDs
     * @summary Strictly internal method used by  microservices to get several users by their ids
     * @param {Array<string>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async getUsersByIds(body?: Array<string>, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetUsersByIdsResponse>> {
        return UserApiFp(this.configuration).getUsersByIds(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get several users by their IDs with basic information
     * @summary Strictly internal method used by  microservices to get several users by their ids with basic information
     * @param {Array<string>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async getUsersByIdsBasicInfo(body?: Array<string>, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetUsersByIdsBasicInfoResponse>> {
        return UserApiFp(this.configuration).getUsersByIdsBasicInfo(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Logs in User to Platform, returns general platform token.
     * @summary Login User to Platform
     * @param {LoginRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async login(body?: LoginRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<LoginResponse>> {
        return UserApiFp(this.configuration).login(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * An api used to change personal password by user
     * @summary Change Password for User
     * @param {PersonalChangePasswordRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async personalChangePassword(body?: PersonalChangePasswordRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<PersonalChangePasswordResponse>> {
        return UserApiFp(this.configuration).personalChangePassword(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * An api to reset password by individual
     * @summary Reset Password By Individual
     * @param {ResetPasswordByIndRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async resetPasswordByUser(body?: ResetPasswordByIndRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<ResetPasswordByIndResponse>> {
        return UserApiFp(this.configuration).resetPasswordByUser(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * An api used to change password of individuals with a verification code, when they forget the password
     * @summary Set New Password for User
     * @param {SetNewPasswordRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public async setNewPassword(body?: SetNewPasswordRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<SetNewPasswordResponse>> {
        return UserApiFp(this.configuration).setNewPassword(body, options).then((request) => request(this.axios, this.basePath));
    }
}